import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_ENDPOINTS } from "../API/EndPoints";
import AxiosInstance from "../API/AxiosInstance";

export const getUpcomingAppointments = createAsyncThunk(
  "master/getUpcomingAppointments",
  async (_, { rejectWithValue }) => {
    try {
      const response = await AxiosInstance.get(
        API_ENDPOINTS.UPCOMMING_APPOINTMENT
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const rescheduleAppointment = createAsyncThunk(
  "master/rescheduleAppointment",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosInstance.put(
        API_ENDPOINTS.RESCHEDULE_APPOINTMENT,
        null,
        { params: data }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const cancelAppointment = createAsyncThunk(
  "master/cancelAppointment",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosInstance.put(
        API_ENDPOINTS.CANCEL_APPOINTMENT,
        null,
        { params: data }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

const upcomingAppointmentsSlice = createSlice({
  name: "getUpcomingAppointments",
  initialState: {
    items: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUpcomingAppointments.pending, (state) => {
        state.loading = true;
      })
      .addCase(getUpcomingAppointments.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(getUpcomingAppointments.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default upcomingAppointmentsSlice.reducer;
